import { createSelector } from "reselect";

import { makeSelectAppKeys } from "../../app/appSelectors";

export const getAppStoreTitle = createSelector(
    makeSelectAppKeys(), appKeys => appKeys.appStoreTitle || ''
)

export const getAppStoreLinkApple = createSelector(
    makeSelectAppKeys(), appKeys => appKeys.appStoreLinkApple
)

export const getAppStoreLinkGoogle = createSelector(
    makeSelectAppKeys(), appKeys => appKeys.appStoreLinkGoogle
)
